import { jsxs as g, jsx as a } from "react/jsx-runtime";
import { c as p } from "./index.CWkFp9WS.js";
import '../assets/ODSIcon.css';/* empty css                 */
const w = ({
  size: o,
  fill: e = "currentColor",
  color: n = "currentColor",
  selected: d = !1,
  decorative: h = !1,
  accessibilityTitle: l,
  focusable: i = !1,
  small: r = !1,
  className: c,
  ...s
}) => {
  const t = o || (r ? 16 : 24);
  return /* @__PURE__ */ g(
    "svg",
    {
      className: p("ODSIcon", c),
      xmlns: "http://www.w3.org/2000/svg",
      width: t,
      height: t,
      viewBox: r ? "0 0 16 16" : "0 0 24 24",
      "aria-hidden": !!h,
      tabIndex: i ? 0 : -1,
      ...s,
      children: [
        l && /* @__PURE__ */ a("title", { children: l }),
        /* @__PURE__ */ a("g", { fill: e === "currentColor" ? n : e, children: d ? r ? /* @__PURE__ */ a("g", { children: /* @__PURE__ */ a("path", { d: "M4.948 3.546a.8.8 0 0 0 .205 1.113L9.998 8l-4.845 3.342a.8.8 0 1 0 .908 1.317l5.8-4a.8.8 0 0 0 0-1.317l-5.8-4a.8.8 0 0 0-1.113.204" }) }) : /* @__PURE__ */ a("g", { children: /* @__PURE__ */ a("path", { d: "M6.966 5.307a1.25 1.25 0 0 0 .346 1.733l7.44 4.96-7.44 4.96A1.25 1.25 0 0 0 8.7 19.04l9-6a1.25 1.25 0 0 0 0-2.08l-9-6a1.25 1.25 0 0 0-1.733.347" }) }) : r ? /* @__PURE__ */ a("g", { children: /* @__PURE__ */ a("path", { d: "M5.114 3.66a.6.6 0 0 0 .153.834L10.351 8l-5.084 3.506a.6.6 0 0 0 .681.988l5.8-4a.6.6 0 0 0 0-.988l-5.8-4a.6.6 0 0 0-.834.153" }) }) : /* @__PURE__ */ a("g", { children: /* @__PURE__ */ a("path", { d: "M7.174 5.445a1 1 0 0 0 .277 1.387L15.203 12l-7.752 5.168a1 1 0 0 0 1.11 1.664l9-6a1 1 0 0 0 0-1.664l-9-6a1 1 0 0 0-1.387.277" }) }) })
      ]
    }
  );
};
export {
  w as default
};
//# sourceMappingURL=ODSNavigationRight.Da0xs0J9.js.map
